import { FontAwesome5 } from '@expo/vector-icons';
import {
  OEButton,
  OETag,
  ph,
  LinkButton,
} from '@openeducation/oe-it-components';
import { arrayParseDate, getTimeFromDate } from '@openeducation/oe-it-services';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { DataTable } from 'react-native-paper';

import { cellFlex } from './active-class-card.helper';
import { ActiveClass } from '../../interfaces/active-class';
import { getLevelShortName, getRoleTag } from '../../utils/get-labels';

interface ActiveClassCardTableItemProps extends ActiveClass {
  onEnterMonitorPress: () => void;
  onTeachPress: () => void;
  checkIfTeachClassLinkEnabled: (classBegin?: Date, dateEnd?: Date) => boolean;
  onSeeStudentListPress: (students: { name: string }[]) => void;
}
export const ActiveClassCardTableItem = ({
  onEnterMonitorPress,
  onTeachPress,
  checkIfTeachClassLinkEnabled,
  onSeeStudentListPress,
  ...item
}: ActiveClassCardTableItemProps) => {
  const showStudentList = () => {
    onSeeStudentListPress(
      item.studentIdsAndNames.map((student) => ({
        name: student.attendanceName,
      }))
    );
  };
  return (
    <DataTable.Row key={item.id} style={[ph(0)]}>
      <CellView flex={cellFlex.link}>
        <OEButton size="small" onPress={onEnterMonitorPress}>
          Enter Class
        </OEButton>
      </CellView>
      <CellView flex={cellFlex.teacherPresent}>
        {item.teacherPresent ? (
          <OnlineIcon />
        ) : (
          <OEButton
            disabled={
              !checkIfTeachClassLinkEnabled?.(
                arrayParseDate(item.classBegin),
                arrayParseDate(item.classEnd)
              )
            }
            size="small"
            type="danger"
            onPress={onTeachPress}
          >
            {'Teach Class '}
            <FontAwesome5 name="exclamation-triangle" />
          </OEButton>
        )}
      </CellView>
      <Cell flex={cellFlex.id}>{item.id}</Cell>
      <Cell flex={cellFlex.teacherName}>{item.teacherName}</Cell>
      <Cell flex={cellFlex.w2wID}>{item.w2wID}</Cell>
      <Cell flex={cellFlex.role}>
        <OETag>{getRoleTag(item.role)}</OETag>
      </Cell>
      <Cell flex={cellFlex.studentNames}>
        <LinkButton text="View Students" onPress={showStudentList} />
      </Cell>
      <Cell flex={cellFlex.classBegin}>{getTimeFromDate(item.classBegin)}</Cell>
      <Cell flex={cellFlex.title}>{item.title}</Cell>
      <Cell flex={cellFlex.teachingTime}>{item.teachingTime}</Cell>
      <Cell flex={cellFlex.language}>{item.language}</Cell>
      <Cell flex={cellFlex.levelId}>{getLevelShortName(item.levelId)}</Cell>
    </DataTable.Row>
  );
};

const OnlineIcon = styled(FontAwesome5).attrs({ solid: true, name: 'circle' })`
  color: ${({ theme }) => theme.color.success};
`;

type CellProps = {
  flex: number;
};

const Cell = styled(DataTable.Cell)<CellProps>`
  padding: 4px;

  flex: ${({ flex }) => flex};
`;

const CellView = styled(DataTable.Cell)<CellProps>`
  padding: 4px;
  align-items: center;
  flex: ${({ flex }) => flex};
`;
